function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* eslint-disable no-restricted-globals */


import React, { useState } from 'react';
import PropTypes from "prop-types";
import { EuiButton } from '../../../../src/components/button';
import { EuiContextMenuPanel, EuiContextMenuItem } from '../../../../src/components/context_menu';
import { EuiPopover } from '../../../../src/components/popover';
import { EuiHorizontalRule } from '../../../../src/components/horizontal_rule';
import { useIsWithinBreakpoints } from '../../../../src/services/hooks/useIsWithinBreakpoints';
import { EUI_THEMES } from '../../../../src/themes';
import { ThemeContext } from '../with_theme'; // @ts-ignore Not TS

import { GuideLocaleSelector } from '../guide_locale_selector';
export var GuideThemeSelector = function GuideThemeSelector(_ref) {
  var rest = Object.assign({}, _ref);
  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(GuideThemeSelectorComponent, _extends({
      context: context
    }, rest));
  });
}; // @ts-ignore Context has no type

GuideThemeSelector.propTypes = {
  onToggleLocale: PropTypes.func.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  context: PropTypes.any
};

var GuideThemeSelectorComponent = ({
  context,
  onToggleLocale,
  selectedLocale
}) => {
  const isMobileSize = useIsWithinBreakpoints(['xs', 's']);
  const [isPopoverOpen, setPopover] = useState(false);

  const onButtonClick = () => {
    setPopover(!isPopoverOpen);
  };

  const closePopover = () => {
    setPopover(false);
  };

  const currentTheme = EUI_THEMES.find(theme => theme.value === context.theme) || EUI_THEMES[0];

  const getIconType = value => {
    return value === currentTheme.value ? 'check' : 'empty';
  };

  const items = EUI_THEMES.map(theme => {
    return <EuiContextMenuItem key={theme.value} icon={getIconType(theme.value)} onClick={() => {
      closePopover();
      context.changeTheme(theme.value);
    }}>
        {theme.text}
      </EuiContextMenuItem>;
  });
  const button = <EuiButton size="s" iconType="arrowDown" iconSide="right" color="ghost" minWidth={0} onClick={onButtonClick}>
      {isMobileSize ? 'Theme' : currentTheme.text}
    </EuiButton>;
  return <EuiPopover id="docsThemeSelector" repositionOnScroll button={button} isOpen={isPopoverOpen} closePopover={closePopover} panelPaddingSize="none" anchorPosition="downRight">
      <EuiContextMenuPanel size="s" items={items} />
      {location.host.includes('803') && <>
          <EuiHorizontalRule margin="none" />
          <div style={{
        padding: 8
      }}>
            <GuideLocaleSelector onToggleLocale={onToggleLocale} selectedLocale={selectedLocale} />
          </div>
        </>}
    </EuiPopover>;
};

GuideThemeSelectorComponent.propTypes = {
  onToggleLocale: PropTypes.func.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  context: PropTypes.any
};